<div class="dropdown ihost-dropdown ihost-replace-val">
    <a class="dropdown-toggle" [class.no-caret]="inlineLabel != null" href="#" role="button" [attr.data-bs-toggle]="!readonly ? 'dropdown' : ''"
        aria-expanded="false">
        <span *ngIf="inlineLabel != null" class="d-none d-sm-inline mr-1">{{inlineLabel}} </span>
        <span *ngIf="noSelectionText != null && noSelectionText.length > 0 && selectedItem == null">{{noSelectionText}} </span>
        <span [attr.class]="inlineLabel != null ? 'text-label text-500 text-link' : ''">{{ selectedItem == null ? "" :
            selectedItem[displayProperty] }}</span>
    </a>
    <div class="dropdown-menu dropdown-contained ">
        <a *ngFor="let item of items" (click)="itemSelected(item)"
            [ngClass]="[nestProperty != null && nestProperty.length > 0 && item[nestProperty] > 0 ? 'nest-' + item[nestProperty] : '']"
            class="dropdown-item">{{
            item[displayProperty] }}</a>
    </div>
</div>